import cn from 'classnames';
import SearchForm from './components/SearchForm/SearchForm.css';
import Button from './components/Button/Button.css';
import PassengerForm from './components/PassengerForm/PassengerForm.css';
import SocialAuth from './components/SocialAuth/SocialAuth.css';
import PaymentForm from './components/PaymentForm/PaymentForm.css';
import SearchFormDatepicker from './components/SearchFormDatepicker/SearchFormDatepicker.css';
import SeatsInfoStyles from './components/SeatMap/SeatsInfoStyles.css';
import SeatStyles from './components/SeatMap/SeatStyles.css';
import SeatMapPassenger from './components/SeatMap/Passenger.css';
import SeatMapPassengersStyles from './components/SeatMap/PassengersStyles.css';
import SeatsRecommendPopup from './components/SeatMap/SeatsRecommendPopup.css';
import Airplane from './components/SeatMap/Airplane.css';
import SegmentTab from './components/SegmentTabs/SegmentTab.css';
import AdditionalServiceBanner from './components/AdditionalServiceBanner/AdditionalServiceBanner.css';
import BaggagePage from './components/BaggagePage/BaggagePage.css';
import IncludedBaggage from './components/IncludedBaggage/IncludedBaggage.css';
import AdditionalBaggage from './components/AdditionalBaggage/AdditionalBaggage.css';
import BaggageList from './components/BaggageList/BaggageList.css';
import Baggage from './components/Baggage/Baggage.css';
import BaggageCard from './components/BaggageCard/BaggageCard.css';
import SpecialEquipment from './components/SpecialEquipment/SpecialEquipment.css';
import UpgradeBaggageDialog from './components/UpgradeBaggageDialog/UpgradeBaggageDialog.css';
import Counter from './components/Counter/Counter.css';
import Switch from './components/Switch/Switch.css';
import BaggageTotalPriceBlock from './components/BaggageTotalPriceBlock/BaggageTotalPriceBlock.css';
import BaggageCounter from './components/BaggageCounter/BaggageCounter.css';
import Meal from './components/Meal/Meal.css';
import MealService from './components/MealService/MealService.css';
import Checkout from './components/Checkout/Checkout.css';
import OverweightBaggage from './components/OverweightBaggage/OverweightBaggage.css';
import Results from './components/Results/Results.css';
import ResultsCalandar from './components/Results/Calendar/Calendar.css';
import ResultsOtherDates from './components/Results/OtherDates/OtherDates.css';
import ResultsDisclaimer from './components/Results/Disclaimer/Disclaimer.css';
import ResultsFlightsList from './components/Results/FlightsList/FlightsList.css';
import QuickSearchForm from './components/QuickSearchForm/QuickSearchForm.css';
import QuickSearchFormSummary from './components/QuickSearchForm/Summary/Summary.css';
import WeekCalendar from './components/WeekCalendar/WeekCalendar.css';
import WeekCalendarDay from './components/WeekCalendar/Day/Day.css';
import WeekCalendarSlider from './components/WeekCalendar/Slider/Slider.css';
import DesktopFlightRoute from './components/DesktopFlightRoute/DesktopFlightRoute.css';
import Segment from './components/DesktopFlightRoute/Segment/Segment.css';
import SegmentCommon from './components/Segment/Segment.css';
import StopsInfo from './components/DesktopFlightRoute/Segment/StopsInfo/StopsInfo.css';
import FlightPrice from './components/DesktopFlightRoute/FlightPrice/FlightPrice.css';
import SingleFlightSegmentPoint from './components/DesktopFlightRoute/SingleFlightSegment/Point/Point.css';
import SingleFlightSegmentRouteArrow from './components/DesktopFlightRoute/SingleFlightSegment/RouteArrow/RouteArrow.css';
import MobileSegmentFlat from './components/MobileSegmentInfo/MobileSegmentFlat/MobileSegmentFlat.css';
import Amenities from './components/Amenities/Amenities.css';
import Stepbar from './components/Stepbar/Stepbar.css';
import StepbarStep from './components/Stepbar/Step/Step.css';
import SelectedFares from './components/Results/SelectedFares/SelectedFares.css';
import Toolbar from './components/Toolbar/Toolbar.css';
import FareLock from './components/FareLock/FareLock.css';
import FareLockSwitch from './components/FareLock/SwitchBlock/SwitchBlock.css';
import FareLockDesc from './components/FareLock/DescriptionBlock/DescriptionBlock.css';
import PriceGraph from './components/PriceGraph/PriceGraph.css';
import MonthsList from './components/PriceGraph/MonthList/MonthList.css';
import Legents from './components/PriceGraph/Legents/Legents.css';
import PriceGraphDay from './components/PriceGraph/Month/Day/Day.css';
import PriceGraphSlider from './components/PriceGraph/Slider/Slider.css';
import Checkin from './components/Checkin/Checkin.css';
import ServiceWithSegments from './components/ServiceWithSegments/ServiceWithSegments.css';
import RetrieveBooking from './components/RetrieveBooking/RetrieveBooking.css';
import CheckinRules from './components/CheckinRules/CheckinRules.css';
import SelectedPassenger from './components/SelectedPassenger/SelectedPassenger.css';
import AddPassenger from './components/AddPassenger/AddPassenger.css';
import StatusMessage from './components/StatusMessage/StatusMessage.css';
import RegisteredPassenger from './components/RegisteredPassenger/RegisteredPassenger.css';
import MobileSegment from './components/MobileSegment/MobileSegment.css';
import Sidebar from './components/Sidebar/Sidebar.css';
import OrderCard from './components/OrderCard/OrderCard.css';
import Account from './components/Account/Account.css';
import Traveller from './components/Traveller/Traveller.css';
import LoginPage from './components/LoginPage/LoginPage.css';
import Timer from './components/Timer/Timer.css';
import MilesHistory from './components/MilesHistory/MilesHistory.css';
import Loyalty from './components/Loyalty/Loyalty.css';
import Passenger from './components/Passenger/Passenger.css';
import MilesRecovery from './components/MilesRecovery/MilesRecovery.css';
import InfoCard from './components/InfoCard/InfoCard.css';
import DesktopFlight from './components/DesktopFlight/DesktopFlight.css';
import FareGroup from './components/FareGroup/FareGroup.css';
import FlightCard from './components/FlightCard/FlightCard.css';
import CompareFares from './components/CompareFares/CompareFares.css';
import Modal from './components/Modal/Modal.css';
import FareConditions from './components/FareConditions/FareConditions.css';
import AircraftPopup from './components/AircraftPopup/AircraftPopup.css';
import MobileFlight from './components/MobileFlight/MobileFlight.css';
import Pagination from './components/Pagination/Pagination.css';
import MobileSelectedFare from './components/MobileSelectedFare/MobileSelectedFare.css';
import Insurance from './components/Insurance/Insurance.css';
import AdditionalServiceWrapper from './components/AdditionalServiceWrapper/AdditionalServiceWrapper.css';
import BusinessLounge from './components/BusinessLounge/BusinessLounge.css';
import CheckoutAdditionalService from './components/CheckoutAdditionalService/CheckoutAdditionalService.css';
import FullscreenDialog from './components/FullscreenDialog/FullscreenDialog.css';
import RefundWrapper from './components/Refund/Wrapper/Wrapper.css';
import Breadcrumbs from './components/Refund/Breadcrumbs/Breadcrumbs.css';
import RefundStepTitle from './components/Refund/StepTitle/StepTitle.css';
import RefundPaper from './components/Refund/RefundPaper/RefundPaper.css';
import RefundPassengers from './components/Refund/Passengers/Passengers.css';
import RefundPassenger from './components/Refund/Passenger/Passenger.css';
import RefundStepsButtons from './components/Refund/StepsButtons/StepsButtons.css';
import RefundNote from './components/Refund/Note/Note.css';
import RefundReason from './components/Refund/Reason/Reason.css';
import RefundRequestForm from './components/Refund/RequestForm/RequestForm.css';
import RefundStatus from './components/Refund/Status/Status.css';
import RefundTicket from './components/Refund/Tiket/Tiket.css';
import MobileStep from './components/Refund/MobileStep/MobileStep.css';
import RefundPrice from './components/Refund/Price/Price.css';
import OrderRefundStatus from './components/Refund/OrderRefundStatus/OrderRefundStatus.css';
import ExchangeChoise from './components/Exchange/Choise/Choise.css';
import ExchangeButtons from './components/Exchange/CommonSelect/CommonSelect.css';
import ExchangeChip from './components/Exchange/Inner/Selections/Chip/Chip.css';
import ExchangeSearchFlights from './components/Exchange/SearchFlights/SearchFlights.css';
import ExchangeSelectedFlights from './components/Exchange/Request/SelectedFlights/SelectedFlights.css';
import ExchangeCreateRequest from './components/Exchange/CreateRequest/CreateRequest.css';
import ExchangeRequestForm from './components/Exchange/RequestForm/RequestForm.css';
import ExchangeRequestControls from './components/Exchange/RequestForm/RequestControls/RequestControls.css';
import ResultsError from './components/ResultsError/ResultsError.css';
import Option from './components/LocationAutocomplete/Option/Option.css';
import MobileDialog from './components/LocationAutocomplete/MobileDialog/MobileDialog.css';
import MobileAuthForm from './components/MobileAuthForm/MobileAuthForm.css';
import ProfileControls from './components/ProfileControls/components/ProfileControls.css';
import AddBooking from './components/AddBooking/components/AddBooking.css';
import DeleteOrderModal from './components/OrderCard/components/DeleteOrderModal/DeleteOrderModal.css';
import InsuranceNew from './components/InsuranceNew/InsuranceNew.css';
import Input from './components/BaseComponents/Input/Input.css';
import Money from './components/Money/Money.css';
import PassengersDetails from './components/PassengersDetails/PassengersDetails.css';
import ServiceSummary from './components/ServiceSummary/ServiceSummary.css';
import Contacts from './components/Contacts/components/Contacts.css';
import AggregationService from './components/CheckoutAdditionalService/CheckoutAdditionalService/Aggregator/AggregatorService.css';
import PassengersToolbar from './components/Checkout/components/Checkout/Form/PassengersToolbar/PassengersToolbar.css';
import MetasearchLoader from './components/MetasearchLoader/components/MetasearchLoader.css';
const theme = {
    MetasearchLoader: {
        MetasearchLoader: {
            logo: MetasearchLoader.logo
        }
    },
    Button: {
        Button: {
            button: Button.button
        }
    },
    PassengersDetails: {
        PassengersDetails: {
            name: PassengersDetails.name,
            title: PassengersDetails.title,
            number: PassengersDetails.number,
            passenger: PassengersDetails.passenger,
            close: PassengersDetails.close,
            item: PassengersDetails.item,
            info: PassengersDetails.info
        }
    },
    PaymentForm: {
        PaymentForm: {
            cards: PaymentForm.paymentForm__card,
            googlepay: PaymentForm.googlepay,
            applepay: PaymentForm.applepay,
            sbp: PaymentForm.sbp
        }
    },
    SearchForm: {
        SearchForm: {
            searchForm: cn(SearchForm.searchForm, QuickSearchForm.searchForm),
            row: SearchForm.row
        },
        OfferHotels: {
            toggle__label: SearchForm.offerHotels_toggle__label,
            toggle_active: SearchForm.offerHotels_toggle_active
        },
        Segments: {
            segments: SearchForm.segments,
            segments_multiCity: SearchForm.segments_multiCity
        },
        Segment: {
            segment: SearchForm.segment,
            input: SearchForm.input,
            cell: SearchForm.searchForm__cell,
            cell_date: SearchForm.cell_dates,
            control: SearchForm.control
        },
        Location: {
            autocomplete: SearchForm.location_autocomplete,
            switcher: SearchForm.switcher,
            switcher_alternative: SearchForm.switcher_alternative,
            input_arrival: SearchForm.input_arrival,
            input_departure: SearchForm.input_departure,
            input_icon: SearchForm.input_icon
        },
        Passengers: {
            passengers: SearchForm.passengers__wrapper,
            passengers_isMultiCity: SearchForm.passengers_multiCity,
            selector: SearchForm.passengers,
            arrowIcon: SearchForm.passengers__arrow,
            title: SearchForm.passengers_title,
            mobileTitle: SearchForm.mobileTitle
        },
        Controls: {
            controls: SearchForm.controls,
            controls_multiCity: SearchForm.controls_multiCity
        },
        StartSearch: {
            startSearch: SearchForm.startSearch,
            startSearch_multiCity: SearchForm.startSearch_multiCity
        },
        Value: {
            wrapper: SearchForm.value__wrapper,
            value: SearchForm.wrapper__value,
            code: SearchForm.wrapper__code
        },
        Datepicker: {
            highlighted_minPrice: SearchFormDatepicker.highlighted_minPrice,
            day__price: SearchFormDatepicker.day__price,
            dates: SearchForm.dates,
            dates__to: SearchForm.dates__to,
            dates__back: SearchForm.dates__back,
            dates_focused: SearchForm.dates_focused,
            placeholder: SearchForm.placeholder,
            oneDate: SearchForm.oneDate,
            highlightedDate_withPrice: SearchForm.highlightedDate_withPrice
        },
        PayByMiles: {
            switchWrapper: SearchForm.payByMiles
        },
        Bottom: {
            bottom: SearchForm.bottom,
            controls: SearchForm.bottom_controls
        },
        Actions: {
            actions: SearchForm.actions,
            addSegment: SearchForm.addSegment
        },
        MultiCity: {
            caption: SearchForm.multiCity_label
        }
    },
    Money: {
        Money: {
            currency_after: Money.currency_after
        }
    },
    BaseComponents: {
        Input: {
            outlined: Input.outlined,
            error: Input.error,
            focused: Input.focused
        }
    },
    Passengers: {
        PassengerStyles: {
            increase: SearchForm.passenger_increase,
            decrease: SearchForm.passenger_decrease,
            passengerType: SearchForm.passengerType,
            age: SearchForm.age
        }
    },
    PassengerForm: {
        Header: {
            number: PassengerForm.number,
            passengerName: PassengerForm.passengerName,
            header: PassengerForm.header,
            filled: PassengerForm.filled,
            payload: PassengerForm.payload
        },
        PassengerForm: {
            form: PassengerForm.passengerForm
        },
        LoyaltyGroup: {
            loyalty_switch: PassengerForm.loyalty_switch
        },
        Group: {
            container: PassengerForm.container,
            field_birthdate: PassengerForm.field_birthdate
        }
    },
    Passenger: {
        Select: {
            icon: PassengerForm.icon,
            real_input: PassengerForm.select_input,
            input: PassengerForm.select,
            helperText: PassengerForm.select__helperText,
            option: PassengerForm.select__option
        },
        Switch: {
            container: Passenger.switch__container,
            element: Passenger.switch__element,
            element_active: Passenger.switch__elementActive,
            element_error: Passenger.switch__elementError,
            error: Passenger.switch__error
        },
        PassengerStyles: {
            form: Passenger.passenger__form,
            form_citizenship: Passenger.passenger__formCitizenship,
            form__field: Passenger.passenger__formField
        }
    },
    Autocomplete: {
        Autocomplete: {
            option: PassengerForm.autocomplete__option
        }
    },
    Input: {
        Input: {
            label_error: PassengerForm.label_error,
            input: PassengerForm.input,
            input_filled: PassengerForm.input_filled,
            input_standard: PassengerForm.input_standard,
            input_error: PassengerForm.input_error,
            textField: PassengerForm.textField_filled,
            textField_focused: PassengerForm.textField_focused,
            textField_standard: PassengerForm.textField_standard,
            label_shrink: PassengerForm.label_shrink,
            hint_error: PassengerForm.hint_error
        }
    },
    Contacts: {
        ContactsStyles: {
            header: PassengerForm.contactHeader,
            description__header: PassengerForm.description__header,
            description__text: PassengerForm.description__text,
            form: PassengerForm.contactForm,
            field: PassengerForm.contactField,
            contacts: cn(PassengerForm.contacts, Contacts.contacts),
            login__modal: PassengerForm.login__modal
        }
    },
    PromoCode: {
        PromoCode: {
            promoCode: SearchForm.promocode,
            contentWrp: SearchForm.promocode__content,
            promoCode_applied: SearchForm.promocode_applied,
            icon: SearchForm.promocode_icon
        },
        PromoCodeForm: {
            button: SearchForm.promocode_button
        }
    },
    SearchFormDatepicker: {
        SearchFormDatepickerStyles: {
            content: SearchFormDatepicker.searchFormDatepicker__content,
            datepicker__disclaimer: SearchFormDatepicker.searchFormDatepicker__datepickerDisclaimer,
            dialog__dates: SearchFormDatepicker.dialog__dates,
            dialog__dateBack: SearchFormDatepicker.dialog__dateBack
        },
        DayStyles: {
            day_withPrice: SearchFormDatepicker.day,
            day_startPeriod: SearchFormDatepicker.day_start,
            day_endPeriod: SearchFormDatepicker.day_end,
            day_inPeriod: SearchFormDatepicker.day_period,
            day_highlighted: SearchFormDatepicker.day_highlighted,
            day_selected: SearchFormDatepicker.day_selected,
            day__price: SearchFormDatepicker.day_price,
            day_hasPrice: SearchFormDatepicker.day_hasPrice
        },
        MonthHeaderStyles: {
            monthHeader__select_month: SearchFormDatepicker.monthHeader__month,
            monthHeader__select_year: SearchFormDatepicker.monthHeader__year
        }
    },
    SeatMap: {
        SeatsInfoStyles: {
            title: SeatsInfoStyles.title,
            classInfo: SeatsInfoStyles.classInfo,
            classInfo__payload: SeatsInfoStyles.classInfo__payload,
            seat: SeatsInfoStyles.seat,
            seat_business: SeatsInfoStyles.seat_business
        },
        SeatMapStyles: {
            wings: SeatMapPassenger.SeatMapStylesWings,
            row__serviceHeader__wrapper: SeatMapPassenger.row__serviceHeader__wrapper
        },
        SeatStyles: {
            seat_business: SeatStyles.seat_business,
            seat_occupied: SeatStyles.seat_occupied,
            seat: SeatStyles.seat,
            seat_recommendCurrent: SeatStyles.seat_recommendCurrent,
            seat_recommend: SeatStyles.seat_recommend,
            number: SeatStyles.number,
            seat_unavailable: SeatStyles.seat_unavailable
        },
        Passenger: {
            item: SeatMapPassenger.item,
            item_active: SeatMapPassenger.item_active,
            avatar: SeatMapPassenger.avatar,
            select: SeatMapPassenger.select,
            money: SeatMapPassenger.money,
            item_recommend: SeatMapPassenger.item_recommend,
            clear: SeatMapPassenger.clear
        },
        PassengersStyles: {
            recommend__label: SeatMapPassengersStyles.recommend__label,
            together: SeatMapPassengersStyles.together,
            passengers__button_clear: SeatMapPassengersStyles.passengers__button_clear,
            passengers__button: SeatMapPassengersStyles.passengers__button,
            recommend__wrapper: SeatMapPassengersStyles.recommend__wrapper,
            passengers__footer: SeatMapPassengersStyles.passengers__footer
        },
        SeatTooltipStyles: {
            tooltip: SeatMapPassenger.tooltip,
            tooltip_recommend: SeatMapPassenger.tooltip_recommend,
            info: SeatMapPassenger.info
        },
        Controls: {
            button: SeatMapPassenger.controlsButton
        },
        ComponentStyles: {
            wrapper: SeatMapPassenger.componentStylesWrapper
        },
        AirplaneStyles: {
            segment: Airplane.segment,
            airplane__name: Airplane.airplane__name
        },
        AirplaneInfoStyles: {
            sunInfo: Airplane.sunInfo
        },
        SeatsRecommendPopup: {
            main: SeatsRecommendPopup.main
        },
        SeatServiceSlide: {
            seat: SeatsInfoStyles.seatService__seat,
            serviceInfo__selectable: SeatsInfoStyles.seatService__selectable
        }
    },
    SegmentTabs: {
        SegmentTab: {
            segment: SegmentTab.segment,
            segment_active: SegmentTab.segment_active,
            ellipse: SegmentTab.ellipse,
            checked: SegmentTab.checked,
            count: SegmentTab.count
        },
        SegmentTabs: {
            title: SegmentTab.segmentTabsTitle
        }
    },
    AdditionalServiceBanner: {
        AdditionalServiceBannerStyles: {
            wrapper: AdditionalServiceBanner.serviceBanner__wrapper,
            baggageBanner: AdditionalServiceBanner.serviceBanner__baggageBanner,
            text: AdditionalServiceBanner.serviceBanner__text,
            image: AdditionalServiceBanner.serviceBanner__image,
            disclaimer: AdditionalServiceBanner.disclaimer
        }
    },
    BaggagePage: {
        BaggagePage: {
            baggage: BaggagePage.baggagePage__container,
            newBaggage: BaggagePage.baggagePage__newBaggage,
            items: BaggagePage.baggagePage__items
        }
    },
    IncludedBaggage: {
        IncludedBaggage: {
            root: IncludedBaggage.includedBaggage__root,
            header: IncludedBaggage.includedBaggage__header,
            upgrade_block: BaggageList.includedBaggage__upgradeBlock,
            footer: IncludedBaggage.includedBaggage__footer
        }
    },
    InsurancePopup: {
        InsuranceCard: {
            content: Insurance.content,
            button: Insurance.button,
            button_reject: Insurance.reject,
            wrapper: Insurance.wrapper,
            active: Insurance.selected,
            header: Insurance.header
        },
        InsurancePopup: {
            header: Insurance.popup__header,
            slider: Insurance.popup__slider,
            slider_button: Insurance.popup__sliderButton
        }
    },
    AdditionalServiceWrapper: {
        AdditionalServiceWrapper: {
            wrapper: AdditionalServiceWrapper.wrapper,
            button: AdditionalServiceWrapper.button,
            cancel: AdditionalServiceWrapper.cancel
        }
    },
    AdditionalServices: {
        Insurance: {
            paper: Insurance.paper
        }
    },
    AdditionalBaggage: {
        AdditionalBaggage: {
            root: AdditionalBaggage.additionalBaggage__root,
            header: AdditionalBaggage.additionalBaggage__header,
            promo_message: AdditionalBaggage.additionalBaggage__promoMessage,
            footer: AdditionalBaggage.additionalBaggage__footer
        }
    },
    BaggageList: {
        BaggageList: {
            root: BaggageList.baggageList__root,
            item: BaggageList.baggageList__item,
            counts: BaggageList.baggageList__counts,
            price: BaggageList.baggageList__price
        },
        BaggageCount: {
            root: BaggageList.baggageCount__root
        },
        BaggageDirection: {
            root: BaggageList.baggageDirection__root
        }
    },
    Baggage: {
        Baggage: {
            root: Baggage.baggage__root,
            icon: Baggage.baggage__icon,
            name: Baggage.baggage__name,
            size: Baggage.baggage__size,
            selected: Baggage.baggage__selected
        }
    },
    MobileAuthForm: {
        MobileAuthForm: {
            wrapper: MobileAuthForm.wrapper,
            title: MobileAuthForm.title,
            button: MobileAuthForm.button
        }
    },
    BaggageCard: {
        BaggageCard: {
            icon: BaggageCard.baggageCard__icon,
            title: BaggageCard.baggageCard__title,
            description: BaggageCard.baggageCard__description,
            header: BaggageCard.baggageCard__header,
            price: BaggageCard.baggageCard__price,
            button: BaggageCard.baggageCard__button,
            button_edit: BaggageCard.baggageCard__buttonEdit
        }
    },
    SpecialEquipment: {
        SpecialEquipment: {
            flight_count: SpecialEquipment.specialEquipment__flightCount,
            flight_info: SpecialEquipment.specialEquipment__flightInfo,
            flight_direction: SpecialEquipment.specialEquipment__flightDirection
        }
    },
    UpgradeBaggageDialog: {
        UpgradeBaggageDialog: {
            modalHeader: UpgradeBaggageDialog.upgradeBaggageDialog__modalHeader,
            close: UpgradeBaggageDialog.upgradeBaggageDialog__close
        },
        HeaderEquipmentItem: {
            wrapper: UpgradeBaggageDialog.headerEquipmentItem__wrapper,
            active: UpgradeBaggageDialog.headerEquipmentItem__active,
            selected: UpgradeBaggageDialog.headerEquipmentItem__selected
        },
        BaggageDialogHeader: {
            category_title: UpgradeBaggageDialog.baggageDialogHeader__categoryTitle,
            category_description: UpgradeBaggageDialog.baggageDialogHeader__categoryDescription,
            price_label: UpgradeBaggageDialog.upgradeBaggageDialog__priceLabel,
            label: UpgradeBaggageDialog.upgradeBaggageDialog__label,
            perFlight: UpgradeBaggageDialog.upgradeBaggageDialog__perFlight,
            description: UpgradeBaggageDialog.upgradeBaggageDialog__description,
            baggage_wrapper: UpgradeBaggageDialog.upgradeBaggageDialog__baggageWrapper,
            price_wrapper: UpgradeBaggageDialog.upgradeBaggageDialog__priceWrapper,
            category__price: UpgradeBaggageDialog.upgradeBaggageDialog__categoryPrice
        },
        BaggageSegment: {
            root: UpgradeBaggageDialog.baggageSegment__root
        },
        BaggagePassenger: {
            root: UpgradeBaggageDialog.baggagePassenger__root,
            number: UpgradeBaggageDialog.baggagePassenger__number,
            name: UpgradeBaggageDialog.baggagePassenger__name,
            checkbox_root: UpgradeBaggageDialog.baggagePassenger__checkboxRoot,
            checkbox_rootChecked: UpgradeBaggageDialog.baggagePassenger__checkboxRootChecked
        },
        BaggageFooter: {
            price_wrapper: UpgradeBaggageDialog.baggageFooter__priceWrapper,
            price_block__delimiter: UpgradeBaggageDialog.baggageFooter__priceBlockDelimiter,
            clear: UpgradeBaggageDialog.baggageFooter__clear,
            cancel_btn: UpgradeBaggageDialog.baggageFooter__cancelBtn,
            confirm_btn: UpgradeBaggageDialog.baggageFooter__confirmBtn
        },
        MobileBaggageSelector: {
            selector: UpgradeBaggageDialog.mobileBaggageSelector__selector,
            selected: UpgradeBaggageDialog.mobileBaggageSelector__selected,
            footer: UpgradeBaggageDialog.upgradeBaggageDialog__footer,
            price: UpgradeBaggageDialog.upgradeBaggageDialog__price
        }
    },
    Counter: {
        Counter: {
            button: Counter.counter__button,
            button_disabled: Counter.counter__buttonDisabled
        }
    },
    Switch: {
        SwitchV2: {
            primary: Switch.switchV2__primary,
            main: Switch.switchV2__main,
            active: Switch.switchV2__active
        }
    },
    BaggageTotalPriceBlock: {
        BaggageTotalPriceBlock: {
            price: BaggageTotalPriceBlock.baggagePrice__price,
            control: BaggageTotalPriceBlock.baggagePrice__control,
            control__edit: BaggageTotalPriceBlock.baggagePrice__priceEdit
        }
    },
    BaggageCounter: {
        BaggageCounter: {
            plus: BaggageCounter.baggageCounter__plus,
            minus: BaggageCounter.baggageCounter__minus,
            hidden: BaggageCounter.baggageCounter__hidden
        }
    },
    Meal: {
        Meal: {
            meal: Meal.meal__container,
            name: Meal.meal__name,
            image: Meal.meal__image,
            footer: Meal.meal__footer,
            price: Meal.meal__price,
            popup__close: Meal.meal__popupClose
        },
        Details: {
            image: Meal.details__image,
            content: Meal.details__content,
            name: Meal.details__name,
            trigger: Meal.details__trigger,
            trigger__icon: Meal.details__triggerIcon,
            description: Meal.details__description,
            selector: Meal.details__selector,
            passenger: Meal.details__passenger,
            passenger__index: Meal.details__passengerIndex,
            counter: Meal.details__counter,
            addForAll: Meal.details__addForAll,
            button: Meal.details__button,
            button_empty: Meal.details__buttonEmpty,
            total: Meal.details__total,
            totalText: Meal.details__totalText,
            clear: Meal.details__clear
        }
    },
    MealService: {
        ServiceWrapper: {
            meals: MealService.mealService__meals
        },
        List: {
            item: MealService.list__item,
            item__icon: MealService.list__itemIcon,
            item_selected: MealService.list__itemSelected
        },
        CategoriesStyles: {
            wrapper: MealService.categories__wrapper,
            category__button: MealService.categories__button
        }
    },
    Checkout: {
        CheckoutStyles: {
            checkoutServices: Checkout.checkoutServices,
            gdsTotalPrice: Checkout.checkout__gdsTotalPrice,
            desktopFlight__flight: PassengerForm.desktopFlight__flight,
            form: PassengerForm.form,
            summary__header: Checkout.checkout__summaryHeader,
            checkout: Checkout.checkout__wrapper,
            container: Checkout.container
        },
        PassengersToolbar: {
            root: cn(PassengerForm.passengerTools, PassengersToolbar.root),
            checkbox: Checkout.passengersToolbar__checkbox
        },
        ThanksBanner: {
            wrapper: Checkout.thanksBanner__wrapper,
            title: Checkout.thanksBanner__title
        }
    },
    ResultsError: {
        ResultsError: {
            body: ResultsError.body,
            wrapper_arrowed: ResultsError.wrapper_arrowed
        }
    },
    ServiceWithSegments: {
        ServiceWithSegments: {
            title: ServiceWithSegments.title
        }
    },
    CheckoutAdditionalService: {
        AggregatorService: {
            icons: AggregationService.icons
        },
        InsuranceUpsale: {
            paper: InsuranceNew.modal__container,
            content: InsuranceNew.insuranceUpsale_content
        },
        CheckoutAdditionalService: {
            service: CheckoutAdditionalService.service,
            service_active: CheckoutAdditionalService.active,
            header: CheckoutAdditionalService.header,
            content: CheckoutAdditionalService.content,
            buttons: CheckoutAdditionalService.buttons,
            add: CheckoutAdditionalService.add
        },
        Business: {
            paper: BusinessLounge.paper,
            business: CheckoutAdditionalService.business,
            business_aggregator: cn(CheckoutAdditionalService.common_aggregator, CheckoutAdditionalService.business_aggregator)
        },
        Vip: {
            vip: cn(CheckoutAdditionalService.vip_aggregator, CheckoutAdditionalService.common_aggregator)
        },
        Seats: {
            seats: CheckoutAdditionalService.seats,
            seats_aggregator: cn(CheckoutAdditionalService.seats_aggregator, CheckoutAdditionalService.common_aggregator)
        },
        CheckoutAdditionalServiceMeal: {
            meal: CheckoutAdditionalService.meal,
            meal_aggregation: cn(CheckoutAdditionalService.common_aggregator, CheckoutAdditionalService.meal_aggregator)
        },
        Insurance: {
            insurance: CheckoutAdditionalService.insurance,
            name: CheckoutAdditionalService.name,
            insurance_aggregator: cn(CheckoutAdditionalService.common_aggregator, CheckoutAdditionalService.insurance_aggregator)
        },
        CheckoutAdditionalServiceBaggage: {
            baggage: CheckoutAdditionalService.baggage,
            caryOnGroup: CheckoutAdditionalService.caryOnGroup,
            baggageGroup: CheckoutAdditionalService.baggageGroup,
            baggageList: CheckoutAdditionalService.baggageList,
            baggage_aggregation: cn(CheckoutAdditionalService.common_aggregator, CheckoutAdditionalService.baggage_aggregator)
        },
        MeetAndGreet: {
            meet_and_greet: cn(CheckoutAdditionalService.common_aggregator, CheckoutAdditionalService.meetAndGreet)
        },
        Aeroexpress: {
            aeroexpress: CheckoutAdditionalService.aeroexpress,
            aeroexpress_aggregator: cn(CheckoutAdditionalService.common_aggregator, CheckoutAdditionalService.aeroexpress_aggregator)
        }
    },
    OverweightBaggage: {
        OverweightBaggage: {
            flight_info: OverweightBaggage.overweightBaggage__flightInfo,
            flight_count: OverweightBaggage.overweightBaggage__flightCount,
            flight_direction: OverweightBaggage.overweightBaggage__flightDirection
        }
    },
    Amenities: {
        Amenities: {
            amenities__item: Amenities.amenities__item,
            amenities__item_unavailable: Amenities.amenities__item_unavailable
        }
    },
    Results: {
        Results: {
            results: Results.results,
            inner: Results.inner,
            header: Results.header,
            toolbar__backButton: Results.toolbar__backButton
        },
        Calendar: {
            header: ResultsCalandar.header,
            legNumber: ResultsCalandar.legNumber,
            title__text: ResultsCalandar.title__text,
            title__cities: ResultsCalandar.title__cities,
            tabs: ResultsCalandar.tabs,
            diagram: ResultsCalandar.diagram,
            priceGraph__modal: ResultsCalandar.priceGraph__modal,
            priceGraph__closeModal: ResultsCalandar.priceGraph__closeModal,
            priceGraph__content: ResultsCalandar.priceGraph__content
        },
        OtherDates: {
            container: ResultsOtherDates.container,
            text: ResultsOtherDates.text
        },
        Disclaimer: {
            wrapper: ResultsDisclaimer.wrapper
        },
        FlightsList: {
            wrapper: ResultsFlightsList.wrapper,
            controls__wrapper: ResultsFlightsList.controls__wrapper,
            leg: ResultsFlightsList.leg
        },
        SelectedFares: {
            wrapper: SelectedFares.wrapper,
            flight: SelectedFares.flight,
            title: SelectedFares.title
        }
    },
    QuickSearchForm: {
        QuickSearchForm: {
            inner: QuickSearchForm.inner,
            form: QuickSearchForm.form,
            wrapper: QuickSearchForm.wrapper,
            opened: QuickSearchForm.opened,
            outer__summary: QuickSearchForm.outer__summary
        },
        Summary: {
            summary: QuickSearchFormSummary.summary,
            route: QuickSearchFormSummary.route,
            passengers: QuickSearchFormSummary.passengers,
            editButtonWrapper: QuickSearchFormSummary.editButtonWrapper
        }
    },
    WeekCalendar: {
        WeekCalendarStyles: {
            dayWrapper: WeekCalendar.dayWrapper,
            dayWrapper_selected: WeekCalendar.dayWrapper_selected
        },
        DayStyles: {
            day: WeekCalendarDay.day,
            day_notAvailable: WeekCalendarDay.day_notAvailable,
            day_selected: WeekCalendarDay.day_selected,
            date: WeekCalendarDay.date,
            date__info: WeekCalendarDay.date__info,
            price__wrapper: WeekCalendarDay.price__wrapper,
            price: WeekCalendarDay.price,
            day_best: WeekCalendarDay.day_best
        },
        SliderStyles: {
            arrow: WeekCalendarSlider.arrow,
            arrow_prev: WeekCalendarSlider.arrow_prev,
            arrow_next: WeekCalendarSlider.arrow_next
        }
    },
    DesktopFlightRoute: {
        DesktopFlightRouteStyles: {
            flight: DesktopFlightRoute.flight,
            segments: DesktopFlightRoute.segments,
            selected: DesktopFlightRoute.selected
        },
        SegmentStyles: {
            segment: Segment.segment,
            flightInfo__container: Segment.flightInfo__container,
            flightInfo: Segment.flightInfo,
            flightInfo__airline: Segment.flightInfo__airline,
            flightInfo__icon: Segment.flightInfo__icon,
            aircraft: Segment.flightInfo__aircraft,
            planeInfo: Segment.planeInfo,
            amenities: Segment.amenities
        },
        FlightPriceStyles: {
            price_selected: FlightPrice.selected,
            price: FlightPrice.price,
            selectFrom_best: FlightPrice.selectFrom_best,
            price__container: FlightPrice.price__container,
            price__money: FlightPrice.price__money,
            fare_family: FlightPrice.fare_family,
            button: FlightPrice.button,
            seats: FlightPrice.seats
        },
        StopsInfoStyles: {
            stop: StopsInfo.stop
        },
        PointStyles: {
            point: SingleFlightSegmentPoint.point,
            point_thin: SingleFlightSegmentPoint.point_thin,
            time: SingleFlightSegmentPoint.time,
            date__container: SingleFlightSegmentPoint.date__container,
            date: SingleFlightSegmentPoint.date
        },
        RouteArrowStyles: {
            flightNumber: SingleFlightSegmentRouteArrow.flightNumber,
            circle: SingleFlightSegmentRouteArrow.circle,
            route: SingleFlightSegmentRouteArrow.route,
            timeInRoute: SingleFlightSegmentRouteArrow.timeInRoute
        }
    },
    MobileSegmentInfo: {
        MobileSegmentFlat: {
            row_first: MobileSegmentFlat.row_first,
            row_last: MobileSegmentFlat.row_last,
            time_arr: MobileSegmentFlat.time_arr,
            time_dep: MobileSegmentFlat.time_dep,
            city: MobileSegmentFlat.city,
            duration__wrapper: MobileSegmentFlat.duration__wrapper,
            duration__text: MobileSegmentFlat.duration__text,
            flightNumber__route: MobileSegmentFlat.flightNumber__route,
            time: MobileSegmentFlat.time,
            transfer: MobileSegmentFlat.transfer
        }
    },
    Stepbar: {
        Stepbar: {
            stepbar: Stepbar.stepbar,
            cart: Stepbar.cart
        },
        Step: {
            step: StepbarStep.step,
            step_active: StepbarStep.step_active,
            label: StepbarStep.label,
            arrow: StepbarStep.arrow,
            icon: StepbarStep.icon,
            title: StepbarStep.title,
            id: StepbarStep.id,
            step_passed: StepbarStep.step_passed
        }
    },
    MobileStepbar: {
        MobileStepbarStyles: {
            stepbar: Checkout.checkout__mobileStepbar
        }
    },
    Toolbar: {
        Toolbar: {
            price: Toolbar.price,
            button: Toolbar.button
        }
    },
    FareLock: {
        FareLock: {
            root: FareLock.root
        },
        SwitchBlock: {
            root: FareLockSwitch.root,
            switch_control: FareLockSwitch.switch_control,
            switch_active: FareLockSwitch.switch_active,
            price_wrapper: FareLockSwitch.price_wrapper,
            switch_wrapper: FareLockSwitch.switch_wrapper
        },
        DescriptionBlock: {
            root: FareLockDesc.root,
            icon: FareLockDesc.icon,
            title: FareLockDesc.title,
            description: FareLockDesc.description
        }
    },
    PriceGraph: {
        PriceGraphStyles: {
            header: PriceGraph.header,
            routeType: PriceGraph.routeType,
            days: PriceGraph.days,
            container: PriceGraph.container
        },
        MonthsListStyles: {
            currentMonth: MonthsList.currentMonth,
            currentMonth__monthName: MonthsList.currentMonth__monthName,
            currentMonth__year: MonthsList.currentMonth__year,
            monthList: MonthsList.monthList
        },
        LegendsStyles: {
            line: Legents.line,
            money: Legents.money,
            line_max: Legents.line_max,
            line_min: Legents.line_min,
            label: Legents.label
        },
        DayStyles: {
            day: PriceGraphDay.day,
            day_notAvailable: PriceGraphDay.day_notAvailable,
            progress: PriceGraphDay.progress,
            number: PriceGraphDay.number,
            tooltip: PriceGraphDay.tooltip,
            tooltip__text: PriceGraphDay.tooltip__text,
            tooltip__date: PriceGraphDay.tooltip__date
        },
        SliderStyles: {
            arrow_prev: PriceGraphSlider.arrow_prev,
            arrow_next: PriceGraphSlider.arrow_next
        }
    },
    Checkin: {
        SelectSegmentsModal: {
            button: Checkin.selectSegments__button,
            header: Checkin.selectSegments__modalHeader
        },
        Inital: {
            wrapper: Checkin.initial__wrapper,
            form: Checkin.initial__form
        },
        Passengers: {
            segments: Checkin.passengers__segments
        }
    },
    CheckinRules: {
        CheckinRules: {
            rules__checkbox: CheckinRules.checkinRules__rulesCheckbox,
            rules__checkbox_checked: CheckinRules.checkinRules__rulesCheckboxChecked,
            rules__button: CheckinRules.checkinRules__rulesButton
        }
    },
    RetrieveBooking: {
        RetrieveBooking: {
            title: RetrieveBooking.retrieveBooking__title,
            button: RetrieveBooking.retrieveBooking__button,
            form__row: RetrieveBooking.retrieveBooking__formRow
        }
    },
    SelectedPassenger: {
        SelectedPassenger: {
            passenger: SelectedPassenger.selectedPassenger__passenger,
            passengerInfo: SelectedPassenger.selectedPassenger__passengerInfo,
            passengerInfo__item: SelectedPassenger.selectedPassenger__passengerInfoItem
        }
    },
    AddPassenger: {
        AddPassenger: {
            wrapper: AddPassenger.addPassenger__wrapper,
            form__wrapper: AddPassenger.addPassenger__formWrapper,
            form: AddPassenger.addPassenger__form,
            addButton: AddPassenger.addPassenger__addButton,
            addButton__icon: AddPassenger.addPassenger__addButtonIcon,
            submitButton: AddPassenger.addPassenger__submitButton,
            passengerIcon: AddPassenger.addPassenger__passengerIcon
        }
    },
    SegmentOld: {
        SegmentCommon: {
            wrapper: SegmentCommon.segmentCommon__wrapper,
            wrapper_business: SegmentCommon.segmentCommon__wrapperBusiness,
            header: SegmentCommon.segmentCommon__header,
            city__weather: SegmentCommon.segmentCommon__cityWeather,
            flightInfo__item: SegmentCommon.segmentCommon__flightInfoItem,
            flightInfo__title: SegmentCommon.segmentCommon__flightInfoTitle,
            flightInfo__value: SegmentCommon.segmentCommon__flightInfoValue,
            city__airport: SegmentCommon.segmentCommon__cityAirport,
            city__info: SegmentCommon.segmentCommon__cityInfo,
            city__iata: SegmentCommon.segmentCommon__cityIata,
            city__time: SegmentCommon.segmentCommon__cityTime,
            plane__icon: SegmentCommon.segmentCommon__planeIcon,
            airline__name: SegmentCommon.segmentCommon__airlineName,
            footer__item: SegmentCommon.segmentCommon__footerItem,
            footer__itemTitle: SegmentCommon.segmentCommon__footerItemTitle,
            footer__itemValue: SegmentCommon.segmentCommon__footerItemValue,
            footer__airline: SegmentCommon.segmentCommon__footer__airline
        }
    },
    StatusMessage: {
        StatusMessage: {
            statusMessage: StatusMessage.statusMessage__wrapper,
            statusMessage_success: StatusMessage.statusMessage__success,
            statusMessage__title: StatusMessage.statusMessage__title,
            statusMessage__text: StatusMessage.statusMessage__text
        }
    },
    RegisteredPassenger: {
        RegisteredPassenger: {
            wrapper: RegisteredPassenger.registeredPassenger__wrapper,
            header: RegisteredPassenger.registeredPassenger__header
        },
        SendToEmail: {
            text: RegisteredPassenger.sendToEmail__text
        }
    },
    MobileSegment: {
        MobileSegment: {
            wrapper: MobileSegment.mobileSegment__wrapper,
            arrivalInfo: MobileSegment.mobileSegment__arrivalInfo
        }
    },
    Sidebar: {
        Sidebar: {
            sidebar: Sidebar.sidebar__wrapper,
            sidebar__item: Sidebar.sidebar__sidebarItem,
            sidebar__item_selected: Sidebar.sidebar__sidebarItemSelected,
            icon: Sidebar.sidebar__icon
        }
    },
    OrderCard: {
        DeleteOrderModal: {
            delete_order: DeleteOrderModal.deleteOrder
        },
        OrderPreview: {
            root: OrderCard.orderPreview__root
        },
        OrderCard: {
            root: OrderCard.orderCard__root,
            container: OrderCard.orderCard__container,
            type_account: OrderCard.orderCard__typeAccount,
            type_review: OrderCard.orderCard__typeReview,
            preview: OrderCard.orderCard__preview,
            openOrder: OrderCard.orderCard__openOrder
        },
        OrderBooking: {
            root: OrderCard.orderBooking__root,
            type_account: OrderCard.orderBooking__typeAccount,
            orderCode: OrderCard.orderBooking__orderCode,
            security_code: OrderCard.orderBooking__securityCode,
            price: OrderCard.orderBooking__price,
            download: OrderCard.orderBooking__download,
            type_review: OrderCard.orderBooking__typeReview
        },
        OrderPassengers: {
            root: OrderCard.orderPassengers__root,
            control: OrderCard.orderPassengers__control
        },
        CommonItem: {
            root: OrderCard.commonItem__root,
            icon: OrderCard.commonItem__icon
        },
        PaymentStatus: {
            root: OrderCard.paymentStatus__root,
            icon: OrderCard.paymentStatus__icon
        },
        OrderStatus: {
            root: OrderCard.orderStatus__root,
            type_review: OrderCard.orderStatus__typeReview,
            confirmed: OrderCard.orderStatus__confirmed,
            icon: OrderCard.orderStatus__icon
        },
        OrderChange: {
            button: OrderCard.orderChange__button
        }
    },
    AccountModule: {
        Account: {
            route__title: Account.account__routeTitle,
            orders__title: Account.account__ordersTitle,
            loginWrapper: Account.account__loginWrapper
        }
    },
    Traveller: {
        Traveller: {
            wrapper: Traveller.traveller__wrapper,
            header: Traveller.traveller__header,
            title__traveller: Traveller.traveller__title
        }
    },
    LoginPage: {
        RegistrationForm: {
            label: LoginPage.register__label
        }
    },
    Timer: {
        Timer: {
            sliding: Timer.timer__sliding,
            link: Timer.timer__link
        }
    },
    MilesHistory: {
        MilesHistory: {
            listHeader: MilesHistory.milesHistory__listHeader,
            listItem_col: MilesHistory.milesHistory__listItemCol,
            label_accrued: MilesHistory.milesHistory__labelAccrued,
            label_spent: MilesHistory.milesHistory__labelSpent,
            listItem: MilesHistory.milesHistory__listItem,
            title: MilesHistory.milesHistory__title
        }
    },
    Loyalty: {
        Loyalty: {
            milesStatus__header: Loyalty.loyalty__milesStatus,
            miles__total: Loyalty.loyalty__milesTotal,
            miles__left: Loyalty.loyalty__milesLeft,
            miles__link: Loyalty.loyalty__milesLink,
            miles: Loyalty.loyalty__miles,
            progress: Loyalty.loyalty__progress,
            milesStatus__value: Loyalty.loyalty__milesStatusValue
        }
    },
    MilesRecovery: {
        MilesRecoveryContentStyles: {
            wrapper: MilesRecovery.milesRecovery__wrapper,
            header: MilesRecovery.milesRecovery__header,
            about: MilesRecovery.milesRecovery__about,
            buttons: MilesRecovery.milesRecovery__buttons
        }
    },
    Account: {
        Account: {
            account__offers: Account.account__offers,
            checkbox: Account.account__checkbox,
            checked: Account.account__checkboxChecked,
            social__networks: Account.account__socialNetworks
        },
        InfoField: {
            indicator: Account.infoField__indicator,
            inputBase: Account.infoField__inputBase,
            tooltip: Account.infoField__tooltip
        },
        SocialButton: {
            social__buttons__wrapper: Account.socialButton__wrapper
        }
    },
    InfoCard: {
        InfoCard: {
            header: InfoCard.infoCard__header,
            subtitle: InfoCard.infoCard__subtitle,
            content: InfoCard.infoCard__content,
            content__item: InfoCard.infoCard__contentItem,
            content__item__name: InfoCard.infoCard__contentItemName,
            content__item__value: InfoCard.infoCard__contentItemValue,
            footer: InfoCard.infoCard__footer,
            footer__button: InfoCard.infoCard__footerButton,
            card_dummy: InfoCard.infoCard__cardDummy
        }
    },
    DesktopFlight: {
        DesktopFlightModalHeader: {
            container: DesktopFlight.flightHeader__container,
            title: DesktopFlight.flightHeader__title,
            close: DesktopFlight.flightHeader__close
        },
        ModalContent: {
            content_wrapper: DesktopFlight.desktopFlightModal__contentWrapper,
            fareGroup__button: DesktopFlight.content__fareGroupButton,
            fareGroup__button_active: DesktopFlight.content__fareGroupButtonActive,
            slider: DesktopFlight.content__slider,
            compareFaresLink: DesktopFlight.content__compareFaresLink,
            compareFaresLink_icon: DesktopFlight.content__compareFaresLinkIcon,
            total_time: DesktopFlight.content__totalTime,
            scroll_up: DesktopFlight.content__scrollUp,
            content: DesktopFlight.content,
            paper: DesktopFlight.paper,
            buttons: DesktopFlight.content__buttons,
            pagination: DesktopFlight.content__pagination,
            pagination__index: DesktopFlight.content__paginationIndex
        },
        FlightInfoSegment: {
            card: DesktopFlight.flightInfo__card,
            locations: DesktopFlight.flightInfo__locations,
            location: DesktopFlight.flightInfo__location,
            flight: DesktopFlight.flightInfo__flight,
            transfer: DesktopFlight.flightInfo__transfer,
            isMobile: DesktopFlight.flightInfo__mobile
        },
        Location: {
            time: DesktopFlight.location__time,
            time_iata: DesktopFlight.location__timeIata,
            date: DesktopFlight.location__date,
            date_icon: DesktopFlight.location__dateIcon,
            city: DesktopFlight.location__city,
            terminal: DesktopFlight.location__terminal,
            weather: DesktopFlight.location__weather,
            isMobile: DesktopFlight.location__mobile,
            terminal_city: DesktopFlight.terminal_city
        },
        SelectedFareGroup: {
            fare: DesktopFlight.selectedFare__fare,
            title: DesktopFlight.selectedFare__title,
            keyFeature: DesktopFlight.selectedFare__keyFeature,
            rules: DesktopFlight.rules,
            button: DesktopFlight.selectedFare__button,
            button__rules: DesktopFlight.selectedFare__buttonRules,
            option: DesktopFlight.selectedFare__option
        },
        DesktopFlightModalContentSelected: {
            segment__card: DesktopFlight.contentSelected__segmentCard,
            segment__flight: DesktopFlight.contentSelected__segmentFlight,
            content: DesktopFlight.contentSelected__content,
            time: DesktopFlight.contentSelected__time
        },
        DesktopFlightPopup: {
            paper: DesktopFlight.desktopFlightPopup__paper,
            scrollBody: DesktopFlight.desktopFlightPopup__scrollBody
        }
    },
    LocationAutocomplete: {
        Option: {
            label: Option.label,
            code: Option.code
        },
        MobileDialog: {
            input: MobileDialog.input,
            hint: MobileDialog.hint
        }
    },
    FareGroup: {
        FareGroup: {
            fareGroup: FareGroup.fareGroup__container,
            fareGroup_white: FareGroup.fareGroup__white,
            button: FareGroup.fareGroup__button,
            option: FareGroup.fareGroup__option,
            option__title: FareGroup.fareGroup__optionTitle,
            option__value: FareGroup.fareGroup__optionValue,
            fareGroup_unavailable: FareGroup.fareGroup__unavailable,
            fareGroup_Business: FareGroup.fareGroup__business,
            option_unavailable: FareGroup.option_unavailable
        },
        FareGroupGrid: {
            recommended: FareGroup.fareGroupGrid__recommended,
            header: FareGroup.fareGroupGrid__header,
            small: FareGroup.fareGroupGrid__small,
            icon: FareGroup.fareGroupGrid__icon,
            paid: FareGroup.fareGroupGrid__paid,
            option: FareGroup.fareGroupGrid__option,
            availabilityIcon: FareGroup.fareGroupGrid__availabilityIcon,
            upgradeOffer: FareGroup.fareGroupGrid__upgradeOffer
        },
        RecommendedBadge: {
            badge: FareGroup.recommendedBadge__badge
        },
        FareGroupIcon: {
            container: FareGroup.fareGroupIcon__container
        }
    },
    FlightCard: {
        FlightCard: {
            airline: FlightCard.flightCard__airline,
            airline__name: FlightCard.flightCard__airlineName,
            airline__number: FlightCard.flightCard__airlineNumber,
            flight: FlightCard.flightCard__flight,
            aircraft__name: FlightCard.flightCard__aircraftName,
            info: FlightCard.flightCard__info
        }
    },
    SocialAuth: {
        SocialAuth: {
            button_facebook: SocialAuth.facebook,
            button_google: SocialAuth.google
        }
    },
    CompareFares: {
        CompareFares: {
            image: CompareFares.compareFares__image,
            compareFares: CompareFares.compareFares__container,
            tableRow: CompareFares.compareFares__tableRow,
            title: CompareFares.compareFares__title,
            groupTitle: CompareFares.compareFares__groupTitle,
            cell: CompareFares.compareFares__cell,
            slider: CompareFares.compareFares__slider,
            slider_withoutImages: CompareFares.slider_withoutImages,
            fareHeadingItem: CompareFares.compareFares__fareHeadingItem,
            fareHeadingItem_isKey: CompareFares.compareFares__fareHeadingItemIsKey,
            link: CompareFares.compareFares__link,
            cellContent: CompareFares.compareFares__cellContent
        }
    },
    Modal: {
        Modal: {
            modal: Modal.modal__container,
            closeIcon: Modal.modal__closeIcon
        }
    },
    FareConditions: {
        FareConditions: {
            paperRoot: FareConditions.fareConditions__paperRoot,
            tabsWrp: FareConditions.fareConditions__tabsWrp,
            tab: FareConditions.fareConditions__tab,
            tab_active: FareConditions.fareConditions__tabActive,
            tabIndicator: FareConditions.fareConditions__tabIndicator,
            fareConditionsSegmentHeading: FareConditions.fareConditions__content,
            segmentTabs: FareConditions.fareConditions__segmentTabs,
            segmentTabsTab: FareConditions.fareConditions__segmentTabsTab
        }
    },
    AircraftPopup: {
        AircraftPopup: {
            close: AircraftPopup.close
        },
        AircraftPopupContent: {
            groups_item: AircraftPopup.groups_item,
            groups_itemDescription: AircraftPopup.groups_itemDescription,
            groups_itemValue_text: AircraftPopup.groups_itemValue_text,
            groups_itemTitle: AircraftPopup.groups_itemTitle,
            groups_itemUnit: AircraftPopup.groups_itemUnit,
            groups: AircraftPopup.groups,
            groups_itemIcon: AircraftPopup.groups_itemIcon,
            title: AircraftPopup.title,
            header: AircraftPopup.header,
            PassengerCapacity: AircraftPopup.PassengerCapacity
        }
    },
    MobileFlight: {
        FlightStyles: {
            flight: MobileFlight.mobileFlight__flight,
            segments: MobileFlight.mobileFlight__segments,
            price: MobileFlight.mobileFlight__price
        }
    },
    Pagination: {
        Pagination: {
            item: Pagination.pagination__item,
            item_active: Pagination.pagination__itemActive
        }
    },
    MobileSelectedFare: {
        MobileSelectedFareStyles: {
            selectedFare: MobileSelectedFare.selectedFare__container,
            features__title: MobileSelectedFare.selectedFare__featuresTitle,
            features__info: MobileSelectedFare.selectedFare__featuresInfo,
            feature: MobileSelectedFare.selectedFare__feature,
            feature__icon: MobileSelectedFare.selectedFare__featureIcon,
            feature__text: MobileSelectedFare.selectedFare__featureText,
            dialog__header: MobileSelectedFare.selectedFare__dialogHeader
        }
    },
    FullscreenDialog: {
        FullscreenDialog: {
            close__icon: FullscreenDialog.fullscreenDialog__closeIcon
        }
    },
    Refund: {
        Wrapper: {
            title: RefundWrapper.title
        },
        Breadcrumbs: {
            breadcrumb: Breadcrumbs.breadcrumb
        },
        StepTitle: {
            icon: RefundStepTitle.icon,
            text: RefundStepTitle.text
        },
        RefundPaper: {
            paper: RefundPaper.paper
        },
        Passengers: {
            passenger: RefundPassengers.passenger
        },
        Passenger: {
            passenger: RefundPassenger.passenger,
            active: RefundPassenger.active,
            checkbox: RefundPassenger.checkbox,
            label: RefundPassenger.label
        },
        StepsButtons: {
            button: RefundStepsButtons.button,
            backButton: RefundStepsButtons.backButton
        },
        Reason: {
            label: RefundReason.label
        },
        Note: {
            note: RefundNote.note
        },
        RequestForm: {
            checkbox: RefundRequestForm.checkbox,
            agree: RefundRequestForm.aggre,
            formComment: RefundRequestForm.formComment
        },
        Status: {
            waiting: RefundStatus.waiting,
            icon: RefundStatus.icon
        },
        Ticket: {
            title: RefundTicket.title,
            time: RefundTicket.time
        },
        Price: {
            row: RefundPrice.row
        },
        OrderRefundStatus: {
            status: OrderRefundStatus.status,
            rejected: OrderRefundStatus.rejected,
            right: OrderRefundStatus.right,
            title: OrderRefundStatus.title
        },
        MobileStep: {
            header: MobileStep.header
        }
    },
    Exchange: {
        Inner: {
            header__text: RefundWrapper.title,
            closeIcon: RefundWrapper.close
        },
        CommonSelect: {
            icon: RefundStepTitle.icon,
            header: RefundStepTitle.text,
            buttons: ExchangeButtons.buttons,
            button: ExchangeButtons.button,
            back: ExchangeButtons.back
        },
        Choice: {
            container: RefundPaper.paper,
            label: ExchangeChoise.label,
            label_selected: ExchangeChoise.label_selected,
            labelInner: ExchangeChoise.labelInner,
            labelDate: ExchangeChoise.labelDate,
            button: ExchangeChoise.button
        },
        Chip: {
            chip: ExchangeChip.chip,
            close: ExchangeChip.close
        },
        SearchFlights: {
            leg: ExchangeSearchFlights.leg,
            header: ExchangeSearchFlights.header,
            route: ExchangeSearchFlights.route
        },
        Calendar: {
            calendar: ExchangeSearchFlights.calendar
        },
        SelectedFlights: {
            header__name: ExchangeSelectedFlights.header__name,
            change: ExchangeSelectedFlights.change,
            charge: ExchangeSelectedFlights.charge,
            money: ExchangeSelectedFlights.money,
            total: ExchangeSelectedFlights.total,
            total__money: ExchangeSelectedFlights.total__money
        },
        CreateRequest: {
            button: ExchangeCreateRequest.button,
            controls: ExchangeCreateRequest.controls,
            submit: ExchangeCreateRequest.submit,
            field: ExchangeCreateRequest.field,
            main: ExchangeCreateRequest.main
        },
        RequestForm: {
            header: ExchangeRequestForm.header,
            created: ExchangeRequestForm.created
        },
        RequestControls: {
            text: ExchangeRequestControls.text,
            button: ExchangeRequestControls.button,
            refuse: ExchangeRequestControls.refuse
        }
    },
    ProfileControls: {
        ProfileControls: {
            img: ProfileControls.img
        }
    },
    AddBooking: {
        AddBooking: {
            buttonCancel: AddBooking.buttonCancel,
            buttonContinue: AddBooking.buttonContinue,
            bookingExample: AddBooking.bookingExample
        }
    },
    InsurancePage: {
        InsurancePage: {
            wrapper: InsuranceNew.insurancePage__wrapper
        },
        InsurancePrice: {
            price: InsuranceNew.insurancePrice__price
        },
        InsurancePageModal: {
            container: InsuranceNew.modal__container
        }
    },
    Flights: {
        FareButton: {
            startIcon: DesktopFlight.fareButton__startIcon,
            money: DesktopFlight.fareButton__money
        }
    },
    ServiceSummary: {
        ServiceSummaryOption: {
            option__iconIncluded: ServiceSummary.option__iconIncluded
        }
    }
};
export default theme;
